import { render, staticRenderFns } from "./ShopDetail.vue?vue&type=template&id=356018b9&scoped=true"
import script from "./ShopDetail.vue?vue&type=script&lang=js"
export * from "./ShopDetail.vue?vue&type=script&lang=js"
import style0 from "./ShopDetail.vue?vue&type=style&index=0&id=356018b9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356018b9",
  null
  
)

export default component.exports